import React from "react";
import { useTranslation } from "react-i18next";
import { Bar } from "react-chartjs-2";
import ChartState from "./_shared/ChartState";
import { ACCENT, barOptions } from "./_shared/chartTheme";

const DiamondReportsCutGradeComp = ({ data, loading }) => {
  const { t } = useTranslation();
  const list = data || [];

  const chartJsData = {
    labels: list.map((item) => item.CutGrade),
    datasets: [
      {
        label: t("Count"),
        data: list.map((item) => item.CNT),
        backgroundColor: ACCENT,
        borderRadius: 4,
      },
    ],
  };

  return (
    <React.Fragment>
      <div className="edr-panel mt-4">
        <label>
          <b> {t("Diamond CutGrade Searches")} </b>
        </label>
        <div className="chart__section">
          {!loading && list.length > 0 ? (
            <div className="edr-chartwrap edr-tall">
              <Bar data={chartJsData} options={barOptions(false)} />
            </div>
          ) : (
            <ChartState loading={loading} />
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default DiamondReportsCutGradeComp;
